export { default } from "./WritePromptTextInput";
